import { useViewport } from 'hooks/3catinfo/useViewport';
import { getPreposition } from '@portal-internet/core';
import Icona from 'components/3catinfo/ui/Icona';
import Boto from 'components/3catinfo/Boto';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './titol.module.scss';

export default function Titol(props) {
    const {
        titol,
        prefix,
        sufix,
        afegirPreposicioTitol,
        tipus,
        tag,
        className,
        sliderId,
        icona,
        iconaTitol,
        text,
        estil,
        estilTitolMes,
        estilBoto,
        isIconaBlanc,
        tema,
        link,
        linkTipus,
        slug,
        mostrarBotoMesItems,
        fons,
        ariaLabel,
        dataTestId,
        idDom
    } = props;

    const { zoomNavigator } = useViewport();
    const route = {
        href: link,
        type: linkTipus,
        slug: slug
    };

    let Tag = tag;

    if (__isEmpty(Tag)) {
        if (tipus === 'seccio') {
            Tag = 'h2';
        } else {
            Tag = 'h1';
        }
    }

    const _netejaTitolTira = () => {
        if (!titol) return titol;
        let titolPrint = titol.replace(/\*\[([^\][]*)]\*/g, '').trim();
        titolPrint = afegirPreposicioTitol ? `${getPreposition(titolPrint)}${titolPrint}` : titolPrint;
        return `${prefix || ''}${titolPrint}${sufix || ''}`;
    };

    const styleTitol = clsx({
        [styles.titol]: true,
        [styles[tipus]]: !__isEmpty(tipus),
        [styles[estil]]: !__isEmpty(estil),
        [styles.ambZoom]: zoomNavigator > 2,
        [[className]]: !__isEmpty(className)
    });

    const styleTitolMes = clsx({
        [styles.titolMesWrapper]: true,
        [styles[tipus]]: !__isEmpty(tipus),
        [styles.titolMes]: mostrarBotoMesItems,
        [styles[estilTitolMes]]: !__isEmpty(estilTitolMes),
        [styles[fons]]: !!fons
    });

    const styleTitolMesLink = clsx({
        [styles.titolMes_link]: true,
        [styles.titolMes_link_pr0]: estilTitolMes !== 'boto-ple'
    });

    if (mostrarBotoMesItems) {
        return (
            <div className={styleTitolMes}>
                {titol && (
                    <Tag className={styleTitol} {...(slug && Tag === 'h2' ? { 'data-testid': slug } : {})}>
                        {_netejaTitolTira()}
                    </Tag>
                )}
                <span className={styles.titolMes_tot}>
                    <Boto
                        novaFinestra={false}
                        route={route}
                        text={text}
                        ariaLabel={ariaLabel}
                        estil={estilBoto ?? 'transparent'}
                        className={styleTitolMesLink}
                        tema={tema}
                        icona={icona}
                        isIconaBlanc={estilTitolMes === 'blanc' ? true : isIconaBlanc}
                        fons={fons}
                        iconaInline={true}
                        dataTestId={dataTestId}
                    />
                </span>
            </div>
        );
    }

    if (sliderId) {
        return (
            <Tag className={styleTitol} id={sliderId}>
                {_netejaTitolTira()}
            </Tag>
        );
    }

    if (iconaTitol) {
        return (
            <div className={styles.contentIconaTitol}>
                <span className={styles.iconaTitol} data-testid={`icona-${iconaTitol}`}>
                    <Icona icona={iconaTitol} alt={iconaTitol} mida={40} />
                </span>
                <Tag className={styleTitol}>{_netejaTitolTira()}</Tag>
            </div>
        );
    }

    return (
        <Tag className={styleTitol} data-testid={dataTestId} {...(idDom && { id: idDom })}>
            {_netejaTitolTira()}
        </Tag>
    );
}
